import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentsTabComponent } from '../../../../../../@shared/components/innform-question-sidepanel/tabs/comments/comments-tab.component';
import { COMMENTS_TYPE } from '../../../../../../@core/models/enums';
import { GeoTechnicalAnalysisReportDataService } from '../../../../services/geo-technical-analysis-report-data.service';

@Component({
    selector: 'app-comments-tab-wrapper',
    standalone: true,
    imports: [CommonModule, CommentsTabComponent],
    template: `
        <app-comments-tab class="block h-full w-full overflow-hidden" [itemId]="analysisReportId()"
            [commentsType]="COMMENTS_TYPE.GEOTECHNICAL_ANALYSIS" [readonly]="isViewer"></app-comments-tab>
    `,
    styles: [`
        :host {
            display: block;
            height: 100%;
            width: 100%;
        }
        :host ::ng-deep app-comments-tab > div {
            max-height: 100% !important;
            height: 100%;
        }
        :host ::ng-deep .border-b.border-gray-200 {
            border-image: linear-gradient(to right, transparent 0.75rem, #e5e7eb 0.75rem, #e5e7eb calc(100% - 0.75rem), transparent calc(100% - 0.75rem)) 1;
        }
    `]
})
export class GeoTechnicalAnalysisCommentsTabComponent {
    COMMENTS_TYPE = COMMENTS_TYPE;

    constructor(public dataService: GeoTechnicalAnalysisReportDataService) { }

    get analysisReportId() { return this.dataService.analysisReportId; }

    get isViewer(): boolean {
        const p = this.dataService.permissions();
        return !this.dataService.isOwner() && !this.dataService.isEditor() && !p?.canComment;
    }
}

